import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

import classes from "./PiChart.module.css";

ChartJS.register(ArcElement, Tooltip, Legend);

export const data = {
  labels: ["Ingliz tili", "Ozbek tili", "Matematika", "Tarix", "Rus tili"],
  datasets: [
    {
      label: "ustozlar",
      data: [3, 2, 4, 2, 2],
      backgroundColor: ["#66B5EF", "#32C179", "#F2CE06", "#F74A8A", "#FF8C00"],
      borderWidth: 1,
    },
  ],
};

export default function PieChartComponent() {
  return (
    <div className={classes["pie-chart-wrapper"]}>
      <h2 className={classes["title"]}>Type of Teachers</h2>
      <Doughnut data={data} />
    </div>
  );
}
